// Drives the custom reconnect dialog (Components/Shared/Modals/ReconnectModal.razor). Once that
// element exists, blazor.web.js stops drawing its own overlay; it only toggles the
// components-reconnect-* state classes on it and raises components-reconnect-state-changed.
// Opening, closing and the buttons are handled here. Follows the .NET 10 Blazor template's
// ReconnectModal.razor.js.
//
// This file is concatenated into scripts/dist/bundle.js, which loads in <head> before the
// dialog has been parsed, so setup waits for DOMContentLoaded. Do not also load it with its own
// <script> tag - the listeners would be bound twice.
(function () {
    function init() {
        var dialog = document.getElementById('components-reconnect-modal');
        if (!dialog) return;

        // Last state the framework reported; 'hide' means connected.
        var state = 'hide';

        dialog.addEventListener('components-reconnect-state-changed', function (event) {
            state = event.detail.state;

            if (state === 'hide') {
                document.removeEventListener('visibilitychange', retryWhenVisible);
                if (dialog.open) dialog.close();
                return;
            }

            if (state === 'rejected') {
                // The server is reachable but this session is gone (the site was restarted or
                // redeployed). There is nothing to rejoin, so load a fresh copy of the page.
                location.reload();
                return;
            }

            if (!dialog.open) dialog.showModal();

            if (state === 'failed') {
                // Out of automatic retries. A laptop waking up is the common case, so try again
                // the moment the tab is looked at instead of waiting for a click.
                document.addEventListener('visibilitychange', retryWhenVisible);
            }

            focusVisibleButton();
        });

        // The dialog has no close control on purpose: the page behind it does not work until the
        // connection is back, so Escape must not dismiss it either. Chrome still lets a repeated
        // Escape close a modal dialog, so reopen it if that happens while disconnected.
        dialog.addEventListener('cancel', function (event) { event.preventDefault(); });
        dialog.addEventListener('close', function () {
            if (state !== 'hide') dialog.showModal();
        });

        dialog.querySelectorAll('[data-reconnect-retry]').forEach(function (b) { b.addEventListener('click', retry); });
        dialog.querySelectorAll('[data-reconnect-resume]').forEach(function (b) { b.addEventListener('click', resume); });
        dialog.querySelectorAll('[data-reconnect-reload]').forEach(function (b) {
            b.addEventListener('click', function () { location.reload(); });
        });

        function closeDialog() {
            state = 'hide';
            if (dialog.open) dialog.close();
        }

        // autofocus only applies when showModal() runs, and the dialog is already open by the
        // time a button appears (connecting -> failed), so move focus explicitly - to the
        // primary action (Try Again / Resume) rather than whichever button comes first.
        // Synchronous on purpose: blazor.web.js sets the state class before raising the event,
        // and requestAnimationFrame never fires in a background tab, which is exactly where a
        // dropped connection is usually waiting when the visitor comes back.
        function focusVisibleButton() {
            var visible = Array.prototype.filter.call(dialog.querySelectorAll('button'), function (b) {
                return b.getClientRects().length > 0;
            });
            var button = visible.find(function (b) { return b.classList.contains('btn-primary'); }) || visible[0];
            if (button) button.focus();
        }

        // Show the attempt. After automatic retries run out the framework's reconnection process
        // is finished, so nothing else will touch these classes until it reports hide - and
        // without this a Try Again that fails leaves the screen exactly as it was, which reads as
        // a broken button. (Blazor's own built-in dialog does the same before retrying.) The
        // failed blocks, buttons included, are hidden meanwhile, so it cannot be double-clicked.
        function showAttempting() {
            state = 'show';
            dialog.classList.remove('components-reconnect-failed');
            dialog.classList.add('components-reconnect-show');
        }

        function showFailedAgain() {
            state = 'failed';
            dialog.classList.remove('components-reconnect-show', 'components-reconnect-retrying');
            dialog.classList.add('components-reconnect-failed');
            focusVisibleButton();
        }

        async function retry() {
            document.removeEventListener('visibilitychange', retryWhenVisible);
            var started = Date.now();
            showAttempting();
            try {
                // true = rejoined (the framework then reports hide); false = server reached but the
                // session is gone; throws = still unreachable.
                var rejoined = await Blazor.reconnect();
                if (!rejoined) {
                    var resumed = await Blazor.resumeCircuit();
                    if (resumed) closeDialog(); else location.reload();
                }
            } catch (err) {
                // An unreachable server usually fails in milliseconds; keep "Reconnecting" up long
                // enough to be seen, or the click still looks like it did nothing.
                await new Promise(function (resolve) {
                    setTimeout(resolve, Math.max(0, 1000 - (Date.now() - started)));
                });
                showFailedAgain();
                document.addEventListener('visibilitychange', retryWhenVisible);
            }
        }

        async function resume() {
            try {
                if (await Blazor.resumeCircuit()) closeDialog(); else location.reload();
            } catch (err) {
                location.reload();
            }
        }

        async function retryWhenVisible() {
            if (document.visibilityState === 'visible') await retry();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
